import React from "react";

import Layout from "../components/Layout";

import Footer from "../components/Footer";
import Header from "../components/Header";
import AboutVid from "../assets/images/AboutVid.webp";
import AboutPckitUpVid from "../assets/video/AboutPckitUp.mp4";
import AboutPckitUpVid2 from "../assets/video/AboutPckitUp2.mp4";

const About = () => {
  return (
    <Layout>
      <Header />
      <header className="masthead aboutMasthead">
        <div className="aboutOverlay" />
        <video
          autoPlay
          muted
          loop
          playsinline="true"
          poster={AboutVid}
          disablePictureInPicture="true"
          className="aboutVid"
        >
          <source src={AboutPckitUpVid} type="video/mp4" />
        </video>
        <div className="container d-flex h-100 align-items-center justify-content-center">
          <div className="headerCard text-center">
            <h1 className="m-0">innovating recycling and refuse disposal</h1>
          </div>
        </div>
      </header>
      <section className="mt-5 mb-5 container">
        <div className="row">
          <div className="col-lg-6 text-center">
            <a
              href="/apply/#agent"
              className="btn btn-primary faqButton faqButtonAgent"
            >
              Agent app
            </a>
          </div>
          <div className="col-lg-6 text-center">
            <a
              href="/apply/#customer"
              className="btn btn-success faqButton faqButtonCustomer m-0"
            >
              Customer app
            </a>
          </div>
        </div>
      </section>

      <section id="projects" className="projects-section projects-section-2">
        <div className="row align-items-center no-gutters">
          <div className="col-lg-10 m-auto">
            <div className="featured-text text-center">
              <p className="text-black mb-5">
                PckitUp provides a technology-mediated on-demand service for
                urban consumers to dispose their household trash and recyclables
                by connecting them to independent agents. described as the uber
                of solid waste, the concept rests on the belief that consumers
                have choice and flexibility in nearly every other facet of their
                lives, yet they are subject to rigid schedules and increasingly
                complex garbage and recycling collection regimens.
              </p>
              <p className="text-black mb-5">
                founded and headquartered in nashville tennessee, PckitUp is
                guided by eco-friendly and social impact tenets. PckitUp is on
                the mission to optimize garbage and recycling disposal in ways
                that improve consumer satisfaction, compliment existing city
                services, and support environmental consciousness. the social
                impact focus of PckitUp is to create sustainable jobs even
                during economic downturns while contributing a fraction of its
                profit towards supporting local charities and organizations in
                the communities it serves.
              </p>
            </div>
          </div>
        </div>
      </section>

      <video
        className="w-100 d-block"
        autoPlay
        muted
        loop
        playsinline="true"
        disablePictureInPicture="true"
      >
        <source src={AboutPckitUpVid2} type="video/mp4" />
      </video>

      <Footer />
    </Layout>
  );
};

export default About;
